export const BUYBACK_QUOTES_FETCH_INTERVAL = 1000

export const BUYBACK_QUOTES_FETCH_TIMEOUT = 20000

/** Price increase ratio that triggers the high-price warning modal (1.5 = 50%) */
export const PRICE_INCREASE_WARNING_THRESHOLD = 1.5

/** Minimum previous price (in currency units) for the warning modal to appear */
export const MIN_PRICE_FOR_WARNING = 10

/** Minimum new price (in currency units) for the warning modal to appear */
export const MIN_NEW_PRICE_FOR_WARNING = 600

export const MODAL_NAMES = {
  SEE_MORE_MARGIN: 'SEE_MORE_MARGIN',
  SEE_MORE_AVERAGE_SELLING_PRICE: 'SEE_MORE_AVERAGE_SELLING_PRICE',
}

export const TRADEIN_ERRORS = {
  FETCH_OPPORTUNITIES:
    '[BUYBACK][API][OPPORTUNITIES] Error fetching opportunities',
  FETCH_MARKETS: '[BUYBACK][API][OPPORTUNITIES] Error fetching markets',
}
